import React, { Component } from 'react';
import { SearchProduct } from '../OrderGuide/AddProduct/SearchProduct';
import { Redirect, Prompt } from 'react-router-dom';
import { PageHeader, PageHeaderRight } from '../shared/PageHeader';
import { GroupDropdown } from './GroupDropdown';
import { toast } from 'react-toastify';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from "moment";
import Textarea from 'react-textarea-autosize';
import ToggleButton from 'react-toggle-button';
import { ModalSelectGuide } from '../shared/modals';
import { DateConst, BlankOrderGuideGroup } from '../shared/consts';

export class OrderGuide extends Component {
    displayName = OrderGuide.name;

    constructor(props) {
        super(props);

        var d0 = new Date();
        var dayName0 = DateConst.days[d0.getDay()];
        var d1 = new Date();
        d1.setDate(d1.getDate() + 1);
        var dayName1 = DateConst.days[d1.getDay()];
        var d2 = new Date();
        d2.setDate(d2.getDate() + 2);
        var dayName2 = DateConst.days[d2.getDay()];
        var d3 = new Date();
        d3.setDate(d3.getDate() + 3);
        var dayName3 = DateConst.days[d3.getDay()];

        this.state = {
            isAdmin: false,
            orderGuide: [],
            loading: true,
            value: '',
            published: false,
            editMode: false,
            suggestions: [],
            responseStatus: 200,
            orderGuideGroupId: undefined,
            orderGuideId: undefined,
            orderGuideGroup: BlankOrderGuideGroup,
            t0: (d0.getMonth() + 1).toString() + "/" + d0.getDate().toString(),
            t1: (d1.getMonth() + 1).toString() + "/" + d1.getDate().toString(),
            t2: (d2.getMonth() + 1).toString() + "/" + d2.getDate().toString(),
            t3: (d3.getMonth() + 1).toString() + "/" + d3.getDate().toString(),
            tName0: dayName0,
            tName1: dayName1,
            tName2: dayName2,
            tName3: dayName3,
            isDirty: false,
            customPublishUntilDate: moment(Date.now()),
            searchHidden: true,
            showSelectGuideModal: false,
            modalGuideGroupId: 0,
            orderGuideGroupList: [],
            customHeaderText: ""
        };
    }

    componentDidMount = async () => {
        this.setState({ loading: true });

        try {
            const fetchConfig = {
                method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            };
            const response = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response.ok) {
                let data = await response.json();

                this.setState({
                    orderGuideGroup: data.orderGuideGroup
                });

                const response2 = await fetch('api/OrderGuide/items', fetchConfig);

                if (response2.ok) {
                    let data2 = await response2.json();

                    this.setState({
                        orderGuideId: data2.orderGuide.orderGuideId,
                        customHeaderText: data2.orderGuide.customHeaderText,
                        orderGuide: data2.orderGuideItems,
                        orderGuideGroupId: data2.orderGuide.orderGuideGroupId,
                        // Pacific time
                        customPublishUntilDate: data2.orderGuide.customDeliveryDate !== null ? moment(data2.orderGuide.customDeliveryDate).subtract(1, 'days') : moment(Date.now()),
                        published: data2.orderGuide.completedDate ? true : false
                    });

                    const fetchConfig3 = {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    };
                    const response3 = await fetch('api/OrderGuide/GuideCopyList/?orderGuideGroupId=' + this.state.orderGuideGroupId, fetchConfig3);
                    if (response3.ok) {
                        let data = await response3.json();
                        this.setState({ orderGuideGroupList: data });

                        if (data.length > 0) {
                            this.setState({ modalGuideGroupId: data[0].orderGuideGroupId });
                        }
                    }
                    else {
                        toast.error("Error retrieving Order Guide Copy List.");
                        console.log("Error retrieving Order Guide Copy List: " + await response3.text());
                    }
                }
                else {
                    this.setState({ responseStatus: response2.status });
                    toast.error("Unable to load Order Guide items.");
                    console.log("Unable to load Order Guide items: " + response2.text());
                }

            } else {
                this.setState({ responseStatus: response.status });
                toast.error("Unable to load Order Guide settings.");
                console.log("Unable to load Order Guide settings: " + response.text());
            }

        } catch (e) {
            console.log("Error in componentDidMount.");
            console.log(e);
        }

        this.setState({ loading: false });
    }

    copyFromModal = async () => {
        // make sure the list of published guides is up to date
        let response = await fetch('api/OrderGuide/GuideCopyList/?orderGuideGroupId=' + this.state.orderGuideGroupId,
            { method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
        if (response.ok) {
            let guideCopyList = await response.json();
            if (guideCopyList.length > 0) {
                this.setState({ showSelectGuideModal: true, modalGuideGroupId: guideCopyList[0].orderGuideGroupId, orderGuideGroupList: guideCopyList });
            }
            else {
                this.setState({ showSelectGuideModal: true, orderGuideGroupList: guideCopyList });
            }
        }
        else {
            toast.error("Error retrieving Order Guide Copy List.");
            console.log("Error retrieving Order Guide Copy List: " + response.text());
        }
    }

    saveGuide = () => {
        const rows = this.state.orderGuide;

        //device time with timezone
        let deliveryDate = moment(this.state.customPublishUntilDate).add(1, 'days');

        let data = {
            "OrderGuideId": rows[0].OrderGuideId,
            "ExpirationDate": '',
            "ExpirationTime": '',
            "DeliveryDate": deliveryDate.format(),
            "CustomHeaderText": this.state.customHeaderText,
            "OrderGuideItemTable": rows
        };

        const fetchConfig = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        fetch('api/OrderGuide/SaveGuide', fetchConfig)
            .then(response => {
                if (response.ok) {
                    toast.success("Order Guide saved.");
                    this.setState({ published: false, isDirty: false });
                }
                else {
                    this.setState({ responseStatus: response.status });
                    toast.error("Unable to save Order Guide.");
                    console.log("Unable to save Order Guide: " + response.text());
                }
            })
            .catch(error => {
                console.log("Error in saveGuide.");
                console.log(error);
            });
    }

    publishGuide = () => {
        const rows = [...this.state.orderGuide];

        //device time with timezone
        var deliveryDate = moment(this.state.customPublishUntilDate).add(1, 'days');

        var data = {
            "OrderGuideId": rows[0].OrderGuideId,
            "ExpirationDate": '',
            "ExpirationTime": '',
            "DeliveryDate": deliveryDate.format(),
            "CustomHeaderText": this.state.customHeaderText,
            "OrderGuideItemTable": rows
        };

        const fetchConfig = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        fetch('api/OrderGuide/PublishGuide', fetchConfig)
            .then(response => {
                if (response.ok) {
                
                    rows.map(function (x) {
                        x.createdInPPro = 0;
                        x.substituted = null;
                        return x;
                    });
                    
                    this.setState({ published: true, editMode: false, isDirty: false, searchHidden: true });
                    toast.success("Order Guide published.");
                }
                else {
                    this.setState({ responseStatus: response.status });
                    toast.error("Unable to publish Order Guide.");
                    console.log("Unable to publish Order Guide: " + response.text());
                }
            })
            .catch(error => {
                console.log("Error in publishGuide.");
                console.log(error);
            });
    }

    deleteRow = (orderGuideItemId, idx) => () => {
        const fetchConfig = {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        fetch('api/OrderGuide/DeleteItem?orderGuideItemId=' + orderGuideItemId, fetchConfig)
            .then(response => {
                if (response.ok) {
                    console.log('index: ' + idx);
                    const rows = [...this.state.orderGuide];
                    rows.splice(idx, 1);
                    this.setState({ orderGuide: rows });
                }
            })
            .catch(error => {
                console.log("Error in deleteRow.");
                console.log(error);
            });
    }

    onBlurNotes = (evt, idx) => {
        if (this.state.orderGuide[idx].notes !== evt.target.value) {
            const og = this.state.orderGuide[idx];
            og.notes = evt.target.value;
            this.setState({ og, isDirty: true });
        }
    }

    onBlurGroupBuyerNotes = (evt, idx) => {
        if (this.state.orderGuide[idx].groupBuyerNotes !== evt.target.value) {
            const og = this.state.orderGuide[idx];
            og.groupBuyerNotes = evt.target.value;
            this.setState({ og, isDirty: true });
        }
    }

    onBlurPrice = (evt, idx) => {
        if (this.state.orderGuide[idx].price !== Number(evt.target.value)) {
            const og = this.state.orderGuide[idx];
            og.price = evt.target.value;
            this.setState({ og, isDirty: true });
        }
    }

    onBlurHeaderText = (evt) => {
        if (this.state.customHeaderText !== evt.target.value) {
            this.setState({ customHeaderText: evt.target.value, isDirty: true });
        }
    }

    onLockItem = (item) => (evt) => {
        if (this.state.editMode || !this.state.published) {
            item.locked = !item.locked;
            this.setState({ item, isDirty: true });
        }
    }

    editGuide = () => {
        this.setState({ editMode: true });
    }

    addItemToGuide = (item) => {
        const fetchConfig = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        fetch('api/OrderGuide/AddItem?orderGuideId=' + this.state.orderGuideId + '&productId=' + item.productId, fetchConfig)
            .then(response => {
                if (response.ok) {
                    response.json()
                        .then(data => {
                            const rows = [...this.state.orderGuide];

                            rows.push({
                                index: rows.length + 1,
                                orderGuideItemId: data.orderGuideItemId,
                                orderGuideId: data.orderGuideId,
                                productId: data.productId,
                                description: data.description,
                                plu: data.plu,
                                isNewProduct: data.isNewProduct,
                                packaging: data.packaging,
                                ogcProductID: data.ogcProductID,
                                qtyInvToday: data.qtyInvToday,
                                expectedToday: data.expectedToday,
                                qtyInvTomorrow: data.qtyInvTomorrow,
                                qtyInvTPlus2: data.qtyInvTPlus2,
                                qtyInvTPlus3: data.qtyInvTPlus3,
                                notes: data.notes,
                                isNWS: data.isNWS,
                                price: data.price,
                                productSKU: data.productSKU
                            });

                            this.setState({ orderGuide: rows });
                            toast.success(`${item.description} added.`);
                        });
                }
                else {
                    response.text()
                        .then(error => {
                            toast.warn("Did not add item. Item may already be in Order Guide.");
                            console.log("Error adding item: " + error);
                        });
                }
            })
            .catch(error => {
                console.log("Error in addItemToGuide.");
                console.log(error);
            });

        return '';
    }

    hideSearch = () => {
        var s = this.state.searchHidden;
        this.setState({ searchHidden: !s });
    }

    onshowGuideModalCancel = () => {
        this.setState({ showSelectGuideModal: false });
    }

    onChangeGuideModal = (event) => {
        this.setState({ modalGuideGroupId: event.target.value });
    }

    onShowGuideModalOK = (modalGuideGroupId) => {
            const fetchConfig = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
        };

        fetch('api/OrderGuide/CopyGuide?orderGuideId=' + this.state.orderGuideId + '&orderGuideCopyId=' + modalGuideGroupId, fetchConfig)
                .then(response => {
                    if (response.ok) {
                        response.json()
                            .then(data => {
                                this.setState({ showSelectGuideModal: false });
                                toast.success(`Guide copied.`);

                                const fetchConfig2 = {
                                    method: 'GET',
                                    headers: {
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    }
                                };
                                fetch('api/OrderGuide/items', fetchConfig2)
                                    .then(response3 => {
                                        if (response3.ok) {
                                            response3.json()
                                                .then(data => {
                                                    this.setState({
                                                        orderGuide: data.orderGuideItems,
                                                        orderGuideId: data.orderGuide.orderGuideId,
                                                        orderGuideGroupId: data.orderGuide.orderGuideGroupId,
                                                        // Pacific time
                                                        customPublishUntilDate: data.orderGuide.customDeliveryDate !== null ? moment(data.orderGuide.customDeliveryDate).subtract(1, 'days') : moment(Date.now()),
                                                        published: data.orderGuide.completedDate ? true : false,
                                                        editMode: false
                                                    });
                                                })
                                                .catch(error => {
                                                    console.log("Error in changeGuide (place 1).");
                                                    console.log(error);
                                                });
                                        }
                                        else {
                                            this.setState({ responseStatus: response3.status });
                                        }
                                    })
                                    .catch(error => {
                                        console.log("Error in changeGuide (place 2).");
                                        console.log(error);
                                    });
                            });
                    }
                    else {
                        response.text()
                            .then(error => {
                                toast.warn("An error has occurred. Did not copy guide.");
                                console.log("Error copying order guide: " + error);
                            });
                    }
                })
                .catch(error => {
                    console.log("Error in copyGuide.");
                    console.log(error);
                });

            return '';
    }

    changeGuide = async (event) => {
        this.setState({ loading: true, customHeaderText: "" });

        if (!this.state.searchHidden)
            this.hideSearch();

        const fetchConfig = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await fetch('api/Token/ChangeOrderGuideGroupClaim?orderGuideGroupId=' + event.target.value, fetchConfig);

        if (response.ok) {
            const auth = await response.json();
            localStorage.setItem('user', JSON.stringify(auth.user));
            localStorage.setItem('token', auth.token);

            try {
                const fetchConfig2 = {
                    method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                };
                const response2 = await fetch('api/OrderGuideGroups/settings', fetchConfig2);
                if (response2.ok) {
                    let data = await response2.json();

                    this.setState({
                        orderGuideGroup: data.orderGuideGroup
                    });

                    const fetchConfig3 = {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    };

                    const response3 = await fetch('api/OrderGuide/items', fetchConfig3);
                    if (response3.ok) {
                        let items = await response3.json();
                        this.setState({
                            orderGuide: items.orderGuideItems,
                            customHeaderText: items.orderGuide.customHeaderText,
                            orderGuideId: items.orderGuide.orderGuideId,
                            orderGuideGroupId: items.orderGuide.orderGuideGroupId,
                            // Pacific time
                            customPublishUntilDate: items.orderGuide.customDeliveryDate !== null ? moment(items.orderGuide.customDeliveryDate).subtract(1, 'days') : moment(Date.now()),
                            published: items.orderGuide.completedDate ? true : false,
                            editMode: false
                        });
                    }
                    else {
                        console.log("Error in changeGuide (place 3).");
                        console.log(response.status);
                        this.setState({ responseStatus: response3.status });
                    }
                }
                else {
                    console.log("Error in changeGuide (place 2).");
                    console.log(response.status);
                    this.setState({ responseStatus: response2.status });
                }
            }
            catch (error) {
                    console.log("Error in changeGuide (place 1).");
                    console.log(error);
            }
        }
        else {
            this.setState({ responseStatus: response.status });
        }
        this.setState({ loading: false });
    }

    render() {
        if (this.state.responseStatus !== 200) { // extreme measure, but assuming 401 for now
            console.log("Going to redirect to / due to response status: " + this.state.responseStatus);
            return (
                <Redirect to="/login" />
            );
        }

        const showEditGuide = this.state.published && !this.state.editMode && !this.state.loading;
        const showSaveGuide = !this.state.published && !this.state.editMode && !this.state.loading;
        const showPublishGuide = (this.state.editMode || !this.state.published) && !this.state.loading;
        const allowMultipleDayOrderGuide = this.state.orderGuideGroup.allowMultipleDayOrderGuide && !this.state.loading;

        return (
            <div>  
                <PageHeader pageTitle="Order Guide"
                    pageHeaderRight={
                        <PageHeaderRight>  
                            {showEditGuide &&
                                <input type="button" className="ogcButton" onClick={this.editGuide} value="Edit Guide" />
                            }
                            {showSaveGuide &&
                                <input type="button" className="ogcButton" onClick={this.saveGuide} value="Save" />
                            }
                            {showPublishGuide &&
                                <input type="button" className="ogcButton" onClick={this.publishGuide} value="Publish Guide" />
                            }
                            {!this.state.loading &&
                                <input type="button" className="ogcButton" onClick={this.copyFromModal} value="Copy from guide" />
                            }
                            {allowMultipleDayOrderGuide &&
                                <div style={{ marginRight: '10px', display: 'inline-block', height: '15px' }} >
                                    <span>Publish Until: </span>
                                     {showPublishGuide &&
                                        <SingleDatePicker
                                            date={this.state.customPublishUntilDate}
                                            onDateChange={customPublishUntilDate => this.setState({ customPublishUntilDate })}
                                            focused={this.state.focused}
                                            onFocusChange={({ focused }) => this.setState({ focused })}
                                            id="your_unique_id"
                                            isOutsideRange={(currDate) => currDate.isBefore(moment(Date.now()), 'day')}
                                            numberOfMonths={1}
                                            readOnly
                                        />
                                    }
                                    {!showPublishGuide &&
                                        <span>{this.state.customPublishUntilDate.format('MM/DD/YYYY')}</span>
                                    }
                                </div>
                            }                          
                            <GroupDropdown onChange={this.changeGuide}
                                value={this.state.orderGuideGroupId}
                                name="orderGuideGroupId"
                            />                          
                            <form action="/Home/Edit" method="get" style={{ display: 'inline-block' }}>
                                <input type="submit" value="Edit Home" className="ogcButton" />
                            </form>
                            <form action="/Admin/OrderGuideGroup" method="get" style={{ display: 'inline-block' }}>
                                <input type="submit" value="Order Guide Settings" className="ogcButton" />
                            </form>
                        </PageHeaderRight>
                    }
                />
                {showPublishGuide &&
                    <div style={{ borderBottom: '1px solid black', width: '99%', marginLeft: '1%' }}>
                        <div>
                            <div style={{ display: 'inline-block', width: '40%' }}>
                                <input defaultValue={this.state.customHeaderText} placeholder="Custom header text" style={{ width: '100%', resize: 'vertical', padding: '3px' }} onBlur={(e) => this.onBlurHeaderText(e)} />
                            </div>
                        </div>
                        <div style={{ display: 'inline-block', width: '100%' }}>
                            <SearchProduct orderGuideId={this.state.orderGuideId} addItemToGuide={this.addItemToGuide} searchHidden={this.state.searchHidden} hideSearch={this.hideSearch} isNWS={this.state.orderGuideGroup.useNWSProducts} />
                        </div>
                    </div>
                }
                <div className="tableFixHeadItems" style={{ overflowY: 'auto', height: !showPublishGuide ? '69.5vh' : this.state.searchHidden ? '61.5vh' : '41.5vh' }} >
                    {this.state.loading && <p style={{ padding: '10px' }}><em>Loading...</em></p>}
                    {!this.state.loading &&
                        <React.Fragment>
                            <table className="table table-hover table-fixed" id="tab_logic">
                                <thead>
                                    <tr>
                                        {this.state.orderGuideGroup.showShortCode &&
                                            <React.Fragment>
                                                <th>Short Code</th>
                                                <th style={{ minWidth: '93px' }}>OGC Product Id</th>
                                            </React.Fragment>
                                        }
                                        <th>Description</th>
                                        <th>Packaging</th>
                                        {this.state.orderGuideGroup.showBrand &&
                                            <th>Brand</th>
                                        }
                                        <th>Stock</th>
                                        {this.state.orderGuideGroup.showIncoming &&
                                            <th colSpan="4" className="centerText">Incoming</th>
                                        }
                                        {this.state.orderGuideGroup.showComments &&
                                            <th>Comments</th>
                                        }
                                        {this.state.orderGuideGroup.showGroupBuyerNotes &&
                                            <th style={{minWidth: '112px'}}>Group Buyer Notes</th>
                                        }
                                        {this.state.orderGuideGroup.showPricing &&
                                            <th>Price</th>
                                        }
                                        <th>Locked</th>
                                        {showPublishGuide &&
                                            <th>Delete</th>
                                        }
                                    </tr>
                                    <tr>
                                        {this.state.orderGuideGroup.showShortCode &&
                                            <React.Fragment>
                                                <th />
                                                <th />
                                            </React.Fragment>
                                        }
                                        <th />
                                        <th />
                                        {this.state.orderGuideGroup.showBrand &&
                                            <th />
                                        }
                                        <th />
                                        {this.state.orderGuideGroup.showIncoming &&
                                            <React.Fragment>
                                                <th>
                                                    {this.state.tName0}
                                                    <br />
                                                    {this.state.t0}
                                                </th>
                                                <th>
                                                    {this.state.tName1}
                                                    <br />
                                                    {this.state.t1}
                                                </th>
                                                <th>
                                                    {this.state.tName2}
                                                    <br />
                                                    {this.state.t2}
                                                </th>
                                                <th>
                                                    {this.state.tName3}
                                                    <br />
                                                    {this.state.t3}
                                                </th>
                                            </React.Fragment>
                                        }
                                        {this.state.orderGuideGroup.showComments &&
                                            <th />
                                        }
                                        {this.state.orderGuideGroup.showGroupBuyerNotes &&
                                            <th />
                                        }
                                        {this.state.orderGuideGroup.showPricing &&
                                            <th />
                                        }
                                        <th />
                                        {showPublishGuide &&
                                            <th />
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.orderGuide.map((orderGuideItem, idx) =>
                                        (<tr key={orderGuideItem.orderGuideItemId} style={{ backgroundColor: (orderGuideItem.substituted === 'Y') ? 'yellow' : (orderGuideItem.createdInPPro === 'Y') ? 'lightgreen' : ''  }} >
                                            {this.state.orderGuideGroup.showShortCode &&
                                                <React.Fragment>
                                                    <td>{orderGuideItem.productSKU}</td>
                                                    <td>{orderGuideItem.ogcProductID}</td>
                                                </React.Fragment>
                                            }
                                            {orderGuideItem.isNWS &&
                                                <td>{orderGuideItem.description}</td>
                                            }
                                            {!orderGuideItem.isNWS &&
                                                <td><strong>[OGC]</strong> {orderGuideItem.description}</td>
                                            }
                                            <td>{orderGuideItem.packaging}</td>
                                            {this.state.orderGuideGroup.showBrand &&
                                                <td>{orderGuideItem.brand}</td>
                                            }
                                            <td>{orderGuideItem.qtyInvToday}</td>
                                            {this.state.orderGuideGroup.showIncoming &&
                                                <React.Fragment>
                                                    <td><span style={{ color: (orderGuideItem.warnLowInvToday) ? 'red' : '' }}>{orderGuideItem.expectedToday}</span></td>
                                                    <td><span style={{ color: (orderGuideItem.warnLowInvTomorrow) ? 'red' : '' }}>{orderGuideItem.qtyInvTomorrow}</span></td>
                                                    <td><span style={{ color: (orderGuideItem.warnLowInvTPlus2) ? 'red' : '' }}>{orderGuideItem.qtyInvTPlus2}</span></td>
                                                    <td><span style={{ color: (orderGuideItem.warnLowInvTPlus3) ? 'red' : '' }}>{orderGuideItem.qtyInvTPlus3}</span></td>
                                                </React.Fragment>
                                            }
                                            {this.state.orderGuideGroup.showComments &&
                                                <React.Fragment>
                                                    {showPublishGuide &&
                                                        <td>
                                                            <Textarea defaultValue={orderGuideItem.notes} style={{ width: '100%', resize: 'vertical', padding: '3px' }} onBlur={(e) => this.onBlurNotes(e, idx)} />
                                                        </td>
                                                    }
                                                    {!showPublishGuide &&
                                                        <td style={{ width: ((this.state.orderGuideGroup.showComments) ? '15%' : '25%') }}>
                                                            {orderGuideItem.notes}
                                                        </td>
                                                    }
                                                </React.Fragment>
                                            }
                                            {this.state.orderGuideGroup.showGroupBuyerNotes &&
                                                <React.Fragment>
                                                    {showPublishGuide &&
                                                        <td>
                                                            <Textarea defaultValue={orderGuideItem.groupBuyerNotes} style={{ width: '100%', resize: 'vertical', padding: '3px' }} onBlur={(e) => this.onBlurGroupBuyerNotes(e, idx)} />
                                                        </td>
                                                    }
                                                    {!showPublishGuide &&
                                                        <td style={{ width: ((this.state.orderGuideGroup.showGroupBuyerNotes) ? '15%' : '25%') }}>
                                                            {orderGuideItem.groupBuyerNotes}
                                                        </td>
                                                    }
                                                </React.Fragment>

                                            }
                                            {this.state.orderGuideGroup.showPricing &&
                                                <td>
                                                    {showPublishGuide &&
                                                        <input defaultValue={orderGuideItem.price} style={{ width: '70px' }} onBlur={(e) => this.onBlurPrice(e, idx)} />
                                                    }
                                                    {!showPublishGuide &&
                                                        <React.Fragment>
                                                            {orderGuideItem.price}
                                                        </React.Fragment>
                                                    }
                                                </td>
                                            }
                                            <td>
                                                <ToggleButton
                                                    inactiveLabel='No'
                                                    activeLabel='Yes'
                                                    readOnly='true'
                                                    value={orderGuideItem.locked}
                                                    onToggle={this.onLockItem(orderGuideItem)}

                                                />
                                            </td>
                                            {showPublishGuide &&
                                                <td>
                                                    <button
                                                        className="btn btn-outline-danger btn-sm deleteButton"

                                                        onClick={this.deleteRow(orderGuideItem.orderGuideItemId, idx)}
                                                    >
                                                        X
                                                    </button>
                                                </td>
                                            }
                                        </tr>)
                                    )}
                                </tbody>
                            </table>
                            <ModalSelectGuide
                                title="Copy from selected guide"
                                orderGuideGroupList={this.state.orderGuideGroupList}
                                orderGuideGroupId={this.state.orderGuideGroupId}
                                show={this.state.showSelectGuideModal}
                                onOK={this.onShowGuideModalOK.bind(this)}
                                onCancel={this.onshowGuideModalCancel.bind(this)}
                                onChange={this.onChangeGuideModal.bind(this)}
                                modalGuideGroupId={this.state.modalGuideGroupId}
                            />
                        </React.Fragment>
                    }
                  
                </div>
                <Prompt when={this.state.isDirty} message="Changes to this Order Guide will be lost. Continue?" />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/OrderGuide/OrderGuide.js